import * as React from "react";
import classnames from "classnames";
/* empty css                */
const IconButton = React.forwardRef(
  ({ variant, outline, disabled, onClick, className, children, ...rest }, ref) => {
    if (!children) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ...rest,
        className: classnames(
          "icon-button",
          {
            "icon-button--outline": outline && !variant,
            [`icon-button--${variant}`]: variant
          },
          className
        ),
        onClick,
        disabled: disabled || false,
        ref,
        type: "button"
      },
      children
    );
  }
);
IconButton.displayName = "IconButton";
export {
  IconButton as default
};
//# sourceMappingURL=IconButton.js.map
